import apiClient from "../utils/apiUtils";

export const registerUser = async (data) => {
  try {
    const response = await apiClient.post("/register", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const loginUser = async (data) => {
  try {
    const response = await apiClient.post("/login", data);
    await new Promise((r) => setTimeout(r, 1000));
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Logout user
export const logoutUser = async (token, userId) => {
  try {
    const response = await apiClient.post(
      "/logout", // Use the correct endpoint for logout
      { user_id: userId }, // Include user_id if required
      {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the Bearer token in headers (for explicit override if needed)
        },
      },
    );
    // console.log("Logout response:", response.data); // Log the response for debugging
    return {
      message: response.data.message || "Logout successful.",
      success: true,
    };
  } catch (error) {
    return {
      message: error.response?.data?.message || "Logout failed.",
      success: false,
    };
    // throw error.response?.data || { message: "An error occurred during logout." };
  }
};

// Fetch user roles and permissions
export const fetchUserDetails = async (token) => {
  try {
    const response = await apiClient.get("/me", {
      headers: { Authorization: `Bearer ${token}` }, // Explicit token for this call
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Refresh authentication token
export const refreshToken = async (refreshTokenValue) => {
  try {
    const payload = refreshTokenValue
      ? { refresh_token: refreshTokenValue }
      : {};
    const response = await apiClient.post("/refresh", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
